var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2DocumentCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 17.3V6H10v56h9v8h45V29.22L53 17.3zM19 58h-5V10h35v5H19v43zm41 8H23V19h26v12h11v35zM29 46h25v4H29v-4zm0-8h25v4H29v-4zm0 16h16v4H29v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Document_copy.db1f8c8f.svg";
export { SvgJ2DocumentCopy as ReactComponent };